import { cn } from "@/lib/utils";
import { MarkSearchedPhraseProps } from ".";

export function MarkSearchedPhrase({
    text,
    searchTerm,
    className,
    markClassName
}: Readonly<MarkSearchedPhraseProps>) {
    if (searchTerm === '') return <p key={text} className={cn(className)}>{text}</p>
    if (!text.toLowerCase().includes(searchTerm.toLowerCase())) return <p className={cn(className)} key={text}>{text}</p>
    
    const regex = new RegExp(`(${searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi'); // NOSONAR
    const parts = text.split(regex);


    return (
        <p className={cn('',className)} key={text}>
            {parts.map((part) => {
                // Check if this part matches the search term (case-insensitive)
                const isMatch = part.toLowerCase() === searchTerm.toLowerCase();

                if (isMatch) {
                    return (
                        <span key={part} className={cn('relative before:absolute before:rounded-md  before:-left-[2px] before:-right-[2px] before:inset-y-0 before:bg-primary/30', markClassName)}>
                            {part}
                        </span>
                    );
                }

                return <span key={part}>{part}</span>;
            })}
        </p>
    )
}